import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import CourseCard from '../../Components/CourseCard';
import ListGroup from '../../Components/ListGroup';
import { fetchAllSeminars, fetchWorkshopsById } from '../../actions/seminars';
import { getSeminars } from '../../selectors/seminars';
import WorkshopCard from '../../Components/WorkshopCard';
import './style.css';
import Loader from '../../Components/Loader';

const Topics = ({
  seminarDetails = [],
  fetchAllSeminars,
  fetchWorkshopsById,
  isIdSpecific = false,
  isLoading,
  error
}) => {
  useEffect(() => {
    isIdSpecific ? fetchWorkshopsById() : fetchAllSeminars();
  }, [isIdSpecific]);
  return (
    <div className="workshop-topics-parent-container">
      <h1 className="workshop-topics-header-container">
        Workshop Topics are Out, Enroll Today!
      </h1>
      <div className="workshop-topics-child-container">
        {isLoading ? (
          <Loader />
        ) : seminarDetails && seminarDetails.length > 0 ? (
          seminarDetails.map((seminar, index) => (
            <WorkshopCard seminar={seminar} />
          ))
        ) : !seminarDetails ? (
          <p>No data present</p>
        ) : (
          error && (
            <p className="workshop-topics-error-container">
              There was an error. Try again later
            </p>
          )
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (store, props) => ({
  seminarDetails: getSeminars(store, props),
  isLoading: store.seminarData.loading,
  error: store.seminarData.error
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchAllSeminars,
      fetchWorkshopsById
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Topics);



// WEBPACK FOOTER //
// ./src/Pages/Workshop/Topics.js